import { useEffect } from "react";
import confetti from "canvas-confetti";
import { Wrench } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function SetupHelperDialog({ open, sites, onClose }) {
  useEffect(() => {
    if (!open) return;
    const o = { zIndex: 9999, particleCount: 80, spread: 70, colors: ["#84cc16", "#10b981", "#0053DA", "#facc15"] };
    confetti({ ...o, angle: 60, origin: { x: 0.15, y: 0.5 } });
    confetti({ ...o, angle: 120, origin: { x: 0.85, y: 0.5 } });
    const t = setTimeout(() => confetti({ ...o, particleCount: 100, spread: 100, startVelocity: 35, origin: { y: 0.4 } }), 220);
    return () => clearTimeout(t);
  }, [open]);
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="w-[calc(100%-1.5rem)] max-w-sm rounded-2xl text-center" data-testid="setup-helper-dialog">
        <div className="mx-auto mt-2 flex h-24 w-24 items-center justify-center rounded-full bg-gradient-to-br from-lime-300 to-emerald-600 p-[3px] shadow-md">
          <div className="flex h-full w-full items-center justify-center rounded-full bg-white text-emerald-700"><Wrench className="h-10 w-10" /></div>
        </div>
        <DialogHeader className="space-y-1 text-center sm:text-center">
          <DialogTitle className="text-2xl font-bold tracking-tight" data-testid="setup-helper-dialog-title">You're a Setup helper!</DialogTitle>
          <DialogDescription data-testid="setup-helper-dialog-text">
            Your setup for <span className="font-semibold text-slate-900">{sites.join(", ")}</span> is live, so every SnapList seller now fills
            that site the way you showed it. Your free week is on its way.
          </DialogDescription>
        </DialogHeader>
        <Button onClick={onClose} className="mt-2 h-11 rounded-full bg-[#0053DA] hover:bg-[#0043B0]" data-testid="setup-helper-dialog-close">
          Nice!
        </Button>
      </DialogContent>
    </Dialog>
  );
}
